<template lang="pug">
AppNav.projects-view-selector
  li.projects-nav--active(:class="{ active: activeView }")
    a(
      href="#"
      @click.prevent="setStatus('active')"
    )
      | Active ({{ activeProjectsCount }})
  li.projects-nav--archived(:class="{ active: archivedView }")
    a(
      href="#"
      @click.prevent="setStatus('archived')"
    )
      | Archived ({{ archivedProjectsCount }})
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'ProjectsViewSelector',
  computed: {
    ...mapState({
      activeProjectsCount: (state) => state.active_projects_count,
      archivedProjectsCount: (state) => state.archived_projects_count,
    }),
    ...mapGetters(['activeView', 'archivedView']),
  },
  methods: {
    ...mapActions(['setStatus']),
  },
};
</script>
